import ReactDOM from "react-dom";
import { betCheckObj, toFixedWithoutRounding } from "../../Utils/Toast";
import moment from "moment";
import { act, useState } from "react";
import { isEmpty, startCase } from "lodash";
const BettingSettledDetail = ({ setSingle, data, betType }) => {
  const [active, setActive] = useState([]);
  let total = toFixedWithoutRounding(Math.abs(data?.total));
  let list =
    betType == "casino"
      ? data
      : data?.markets
          ?.map((res) => {
            return res?.bets_list?.map((item) => {
              return {
                ...item,
                market: betType == "fancy" ? "Fancy Bet" : res?.market,
              };
            });
          })
          .flat();

  return (
    <div
      _ngcontent-serverapp-c221247831
      className="dialog-wrap ng-trigger ng-trigger-dialogTriggerAni ng-tns-c221247831-105 ng-star-inserted"
    >
      <div
        _ngcontent-serverapp-c221247831
        className="top-bar ng-tns-c221247831-105"
      >
        <div
          _ngcontent-serverapp-c221247831
          className="bar-title ng-tns-c221247831-105"
        >
          Betting Records Details
        </div>
        <div
          onClick={() => setSingle({})}
          _ngcontent-serverapp-c221247831
          className="back-btn ng-tns-c221247831-105"
          style={{
            "mask-image": 'url("/assets/Other/icon-arrow-type01.svg")',
          }}
        />
      </div>
      <div
        _ngcontent-serverapp-c221247831
        className="cricket-total-wrap ng-tns-c221247831-105"
      >
        <div
          _ngcontent-serverapp-c221247831
          className="title ng-tns-c221247831-105"
        >
          Total Settlement
        </div>
        <div
          _ngcontent-serverapp-c221247831
          className="profit ng-tns-c221247831-105"
        >
          <span
            style={{ color: "white" }}
            _ngcontent-serverapp-c221247831
            className="ng-tns-c221247831-105"
          >
            Profit/Loss
          </span>
          <div
            _ngcontent-serverapp-c221247831
            className="profit-amount ng-tns-c221247831-105 negative"
          >
            <i
              id="locale-util-dicrective-102"
              className="ng-tns-c221247831-105"
              style={{
                display: "initial",
                color: (
                  betType == "casino" ? list?.playerPL > 0 : data?.total > 0
                )
                  ? "green"
                  : "red",
              }}
            >
              {betType == "casino"
                ? list?.playerPL
                : data?.total > 0
                  ? total
                  : `(${total})`}
            </i>
          </div>
        </div>
        {/* <div
          _ngcontent-serverapp-c221247831
          className="platform ng-tns-c221247831-105"
        >
          Exchange
          <span
            _ngcontent-serverapp-c221247831
            className="ng-tns-c221247831-105"
          >
            (Sports)
          </span>
        </div> */}
        {/* <div
          _ngcontent-serverapp-c221247831
          className="turnover ng-tns-c221247831-105"
        >
          <span
            _ngcontent-serverapp-c221247831
            className="ng-tns-c221247831-105"
          >
            Turnover
          </span>
          <div
            _ngcontent-serverapp-c221247831
            className="turnover-amount ng-tns-c221247831-105"
          >
            <i
              id="locale-util-dicrective-103"
              className="ng-tns-c221247831-105"
              style={{ display: "initial" }}
            >
              0
            </i>
          </div>
        </div> */}
      </div>
      <ul
        _ngcontent-serverapp-c221247831
        className="cricket-list-content ng-tns-c221247831-105"
      >
        {betType == "casino" ? (
          <li
            style={{ color: "white" }}
            _ngcontent-serverapp-c3238644402
            className={`accordion-wrap ng-tns-c3238644402-106 ${
              list?.playerPL > 0 ? "win" : "loss"
            } ng-star-inserted`}
          >
            <div
              _ngcontent-serverapp-c3238644402
              className={`accordion-header ng-tns-c3238644402-106 ng-star-inserted`}
            >
              <div
                _ngcontent-serverapp-c3238644402
                className="main-info ng-tns-c3238644402-106"
              >
                <img
                  _ngcontent-serverapp-c3238644402
                  className="ng-tns-c3238644402-106"
                  alt="win"
                  src={
                    list?.playerPL > 0
                      ? "/assets/Other/win.png"
                      : "/assets/Other/lose.png"
                  }
                  loading="lazy"
                />

                <div
                  _ngcontent-serverapp-c3238644402
                  className="title ng-tns-c3238644402-106"
                >
                  <span
                    _ngcontent-serverapp-c3238644402
                    className="category-type ng-tns-c3238644402-106"
                  >
                    {list?.casinoName}
                  </span>
                  <div
                    _ngcontent-serverapp-c3238644402
                    className="parlay-type ng-tns-c3238644402-106"
                    style={{ textTransform: "uppercase" }}
                  >
                    {list?.platform}
                  </div>
                </div>
                <div
                  _ngcontent-serverapp-c3238644402
                  className="arrow-circle ng-tns-c3238644402-106"
                >
                  <div
                    _ngcontent-serverapp-c3238644402
                    className="arrow ng-tns-c3238644402-106"
                    style={{
                      "mask-image": 'url("/assets/Other/accordion-arrow.svg")',
                    }}
                  />
                </div>
                <div
                  _ngcontent-serverapp-c3238644402
                  className="settled-date ng-tns-c3238644402-106"
                >
                  Settled Date :{" "}
                  <span
                    _ngcontent-serverapp-c3238644402
                    className="ng-tns-c3238644402-106"
                  >
                    {moment(list?.updatedAt).format("YYYY-MM-DD HH:MM:SS")}
                  </span>
                </div>
              </div>

              <div
                _ngcontent-serverapp-c3238644402
                className="bet-bid ng-tns-c3238644402-106"
              >
                {" "}
                Game Code :{" "}
                <span
                  _ngcontent-serverapp-c3238644402
                  className="ng-tns-c3238644402-106"
                >
                  {list?.gameCode}
                </span>
              </div>
              <div
                _ngcontent-serverapp-c3238644402
                className="bet-placed ng-tns-c3238644402-106"
              >
                {" "}
                Bet ID :{" "}
                <span
                  _ngcontent-serverapp-c3238644402
                  className="ng-tns-c3238644402-106"
                >
                  {list?.casinoBetId}
                </span>
              </div>
            </div>
          </li>
        ) : (
          list?.map((res) => {
            return (
              <li
                style={{ color: "white" }}
                onClick={() => {
                  if (active?.includes(res?._id)) {
                    setActive((prev) => {
                      return prev?.filter((item) => {
                        return item != res?._id;
                      });
                    });
                  } else {
                    setActive([...active, res?._id]);
                  }
                }}
                _ngcontent-serverapp-c3238644402
                className={`accordion-wrap ng-tns-c3238644402-106 ${
                  res?.updatedResult > 0 ? "win" : "loss"
                } ng-star-inserted ${active?.includes(res?._id) ? "show" : ""}`}
              >
                <div
                  _ngcontent-serverapp-c3238644402
                  className={`accordion-header ng-tns-c3238644402-106 ng-star-inserted ${
                    active?.includes(res?._id) ? "show" : ""
                  }`}
                >
                  <div
                    _ngcontent-serverapp-c3238644402
                    className="main-info ng-tns-c3238644402-106"
                  >
                    <img
                      _ngcontent-serverapp-c3238644402
                      className="ng-tns-c3238644402-106"
                      alt="win"
                      src={
                        res?.updatedResult > 0
                          ? "/assets/Other/win.png"
                          : "/assets/Other/lose.png"
                      }
                      loading="lazy"
                    />

                    <div
                      _ngcontent-serverapp-c3238644402
                      className="title ng-tns-c3238644402-106"
                    >
                      <span
                        _ngcontent-serverapp-c3238644402
                        className="category-type ng-tns-c3238644402-106"
                      >
                        {res?.market || startCase(betType)}
                      </span>
                      <div
                        _ngcontent-serverapp-c3238644402
                        className="parlay-type ng-tns-c3238644402-106"
                        style={{ textTransform: "uppercase" }}
                      >
                        {betCheckObj[res?.eventType]}
                      </div>
                    </div>
                    <div
                      _ngcontent-serverapp-c3238644402
                      className="arrow-circle ng-tns-c3238644402-106"
                    >
                      <div
                        _ngcontent-serverapp-c3238644402
                        className="arrow ng-tns-c3238644402-106"
                        style={{
                          "mask-image":
                            'url("/assets/Other/accordion-arrow.svg")',
                        }}
                      />
                    </div>
                    <div
                      _ngcontent-serverapp-c3238644402
                      className="settled-date ng-tns-c3238644402-106"
                    >
                      Settled Date :{" "}
                      <span
                        _ngcontent-serverapp-c3238644402
                        className="ng-tns-c3238644402-106"
                      >
                        {moment(res?.updatedAt).format("YYYY-MM-DD HH:MM:SS")}
                      </span>
                    </div>
                  </div>
                  <div
                    _ngcontent-serverapp-c3238644402
                    className="betting-info ng-tns-c3238644402-106"
                  >
                    <div
                      _ngcontent-serverapp-c3238644402
                      className="avg-odds ng-tns-c3238644402-106"
                    >
                      <svg
                        _ngcontent-serverapp-c3238644402
                        className="item-icon ng-tns-c3238644402-106"
                      >
                        <circle
                          _ngcontent-serverapp-c3238644402
                          cx={9}
                          cy={9}
                          r={9}
                          className="circle ng-tns-c3238644402-106"
                        />
                        <use
                          _ngcontent-serverapp-c3238644402
                          href={"/assets/Other/icon-odds.svg"}
                          className="icon ng-tns-c3238644402-106"
                        />
                      </svg>
                      <strong
                        _ngcontent-serverapp-c3238644402
                        className="ng-tns-c3238644402-106"
                      >
                        {betType != "fancy"
                          ? res?.bhav
                          : `${res?.betRun} / ${res?.bhav}`}
                      </strong>
                      <span
                        _ngcontent-serverapp-c3238644402
                        className="ng-tns-c3238644402-106"
                      >
                        Avg. Odds
                      </span>
                    </div>
                    <div
                      _ngcontent-serverapp-c3238644402
                      className="avg-odds ng-tns-c3238644402-106"
                    >
                      <svg
                        _ngcontent-serverapp-c3238644402
                        className="item-icon ng-tns-c3238644402-106"
                      >
                        <circle
                          _ngcontent-serverapp-c3238644402
                          cx={9}
                          cy={9}
                          r={9}
                          className="circle ng-tns-c3238644402-106"
                        />

                        <use
                          _ngcontent-serverapp-c3238644402
                          href={"/assets/Other/icon-turnover.svg"}
                          className="icon ng-tns-c3238644402-106"
                        />
                      </svg>

                      <strong
                        _ngcontent-serverapp-c3238644402
                        className="ng-tns-c3238644402-106"
                      >
                        <i
                          id="locale-util-dicrective-104"
                          className="ng-tns-c3238644402-106"
                          style={{ display: "initial" }}
                        >
                          0
                        </i>
                      </strong>
                      <span
                        _ngcontent-serverapp-c3238644402
                        className="ng-tns-c3238644402-106"
                      >
                        Turnover
                      </span>
                    </div>
                    <div
                      _ngcontent-serverapp-c3238644402
                      className="avg-odds  ng-tns-c3238644402-106"
                    >
                      <svg
                        _ngcontent-serverapp-c3238644402
                        className="item-icon ng-tns-c3238644402-106"
                      >
                        <circle
                          _ngcontent-serverapp-c3238644402
                          cx={9}
                          cy={9}
                          r={9}
                          className="circle ng-tns-c3238644402-106"
                        />
                        <use
                          _ngcontent-serverapp-c3238644402
                          href="/assets/Other/icon-stake.svg"
                          className="icon ng-tns-c3238644402-106"
                        />
                      </svg>
                      <strong
                        _ngcontent-serverapp-c3238644402
                        className="ng-tns-c3238644402-106"
                      >
                        {res?.amount}
                      </strong>
                      <span
                        _ngcontent-serverapp-c3238644402
                        className="ng-tns-c3238644402-106"
                      >
                        Stake ($)
                      </span>
                    </div>
                    <div
                      _ngcontent-serverapp-c3238644402
                      className="profit ng-tns-c3238644402-106"
                    >
                      <svg
                        _ngcontent-serverapp-c3238644402
                        className="item-icon ng-tns-c3238644402-106"
                      >
                        <circle
                          _ngcontent-serverapp-c3238644402
                          cx={9}
                          cy={9}
                          r={9}
                          className="circle ng-tns-c3238644402-106"
                        />
                        <use
                          _ngcontent-serverapp-c3238644402
                          href="/assets/Other/icon-profit.svg"
                          className="icon ng-tns-c3238644402-106"
                        />
                      </svg>
                      <strong
                        _ngcontent-serverapp-c3238644402
                        className="ng-tns-c3238644402-106"
                      >
                        <i
                          id="locale-util-dicrective-105"
                          className="ng-tns-c3238644402-106"
                          style={{
                            display: "initial",
                            color: res?.updatedResult > 0 ? "green" : "red",
                          }}
                        >
                          {res?.updatedResult > 0
                            ? res?.updatedResult
                            : `(${Math.abs(res?.updatedResult)})`}
                        </i>
                      </strong>
                      <span
                        _ngcontent-serverapp-c3238644402
                        className="ng-tns-c3238644402-106"
                      >
                        Profit/Loss
                      </span>
                    </div>
                  </div>
                  <div
                    _ngcontent-serverapp-c3238644402
                    className="bet-bid ng-tns-c3238644402-106"
                  >
                    {" "}
                    BID :{" "}
                    <span
                      _ngcontent-serverapp-c3238644402
                      className="ng-tns-c3238644402-106"
                    >
                      {res?.matchBetId}
                    </span>
                  </div>
                  <div
                    _ngcontent-serverapp-c3238644402
                    className="bet-placed ng-tns-c3238644402-106"
                  >
                    {" "}
                    Bet Placed :{" "}
                    <span
                      _ngcontent-serverapp-c3238644402
                      className="ng-tns-c3238644402-106"
                    >
                      {moment(res?.timeInserted).format("YYYY-MM-DD HH:MM:SS")}
                    </span>
                  </div>
                </div>
                {active?.includes(res?._id) && (
                  <ul
                    _ngcontent-serverapp-c3238644402
                    className="a-content accordion-collapse ng-tns-c3238644402-21 ng-star-inserted"
                  >
                    <li
                      _ngcontent-serverapp-c3238644402
                      className={`parlay-wrap ng-tns-c3238644402-21 ${
                        res?.updatedResult > 0 ? "win" : "lose"
                      } ng-star-inserted`}
                      style={{}}
                    >
                      <svg
                        _ngcontent-serverapp-c3238644402
                        className="event-type ng-tns-c3238644402-21"
                      >
                        <use
                          _ngcontent-serverapp-c3238644402
                          className="ng-tns-c3238644402-21"
                          href={"/assets/Other/icon-cricket.svg"}
                        />
                      </svg>
                      <div
                        _ngcontent-serverapp-c3238644402
                        className="event-name ng-tns-c3238644402-21"
                      >
                        <span
                          _ngcontent-serverapp-c3238644402
                          className="ng-tns-c3238644402-21"
                        >
                          {res?.matchName}
                        </span>
                      </div>
                      <div
                        _ngcontent-serverapp-c3238644402
                        className="market ng-tns-c3238644402-21"
                      >
                        {res?.market || startCase(betType)}
                      </div>
                      <svg
                        _ngcontent-serverapp-c3238644402
                        className="parlay-status ng-tns-c3238644402-21"
                      >
                        <use
                          _ngcontent-serverapp-c3238644402
                          className="ng-tns-c3238644402-21"
                          href={
                            res?.updatedResult > 0
                              ? "/assets/Other/icon-win.svg"
                              : "/assets/Other/icon-lose.svg"
                          }
                        />
                      </svg>
                      <div
                        _ngcontent-serverapp-c3238644402
                        className="details ng-tns-c3238644402-21"
                      >
                        <div
                          _ngcontent-serverapp-c3238644402
                          className="select ng-tns-c3238644402-21"
                        >
                          {" "}
                          {startCase(res?.betType || res?.type)} -{" "}
                          {res?.teamName || res?.fancyName}
                        </div>
                        <div
                          _ngcontent-serverapp-c3238644402
                          className="odds-req ng-tns-c3238644402-21"
                        >
                          <span
                            _ngcontent-serverapp-c3238644402
                            className="record-sub-title ng-tns-c3238644402-21 ng-star-inserted"
                          >
                            Odds req.
                          </span>
                          <strong
                            _ngcontent-serverapp-c3238644402
                            className="ng-tns-c3238644402-21 ng-star-inserted"
                          >
                            {betType != "fancy"
                              ? res?.bhav
                              : `${res?.betRun} / ${res?.bhav}`}
                          </strong>
                        </div>
                        <div
                          _ngcontent-serverapp-c3238644402
                          className="odds-matched ng-tns-c3238644402-21"
                        >
                          <span
                            _ngcontent-serverapp-c3238644402
                            className="record-sub-title ng-tns-c3238644402-21"
                          >
                            Odds Matched
                          </span>
                          <strong
                            _ngcontent-serverapp-c3238644402
                            className="ng-tns-c3238644402-21"
                          >
                            {betType != "fancy"
                              ? res?.bhav
                              : `${res?.betRun} / ${res?.bhav}`}
                          </strong>
                        </div>
                        {/* <div
                                      _ngcontent-serverapp-c3238644402
                                      className="bet-type ng-tns-c3238644402-21"
                                    >
                                      <span
                                        _ngcontent-serverapp-c3238644402
                                        className="record-sub-title ng-tns-c3238644402-21"
                                      >
                                        Bet Type
                                      </span>
                                      <strong
                                        _ngcontent-serverapp-c3238644402
                                        className="ng-tns-c3238644402-21"
                                      >
                                        Main Wallet
                                      </strong>
                                    </div> */}
                      </div>
                    </li>
                  </ul>
                )}
              </li>
            );
          })
        )}
      </ul>
    </div>
  );
};

export default BettingSettledDetail;
